(function anchorScroll(){
  var scrollIterationsCounter = 0;

  $(window).on("load", function () {
      var hash = window.location.hash;
      let shortHash = hash.substring(1);
      let isAnchorScroll = $("body").find(`[data-anchor='${shortHash}']`);
      if ($(hash).length && isAnchorScroll.length){
        scrollToDiv($(hash));
      }
  });

  $('.js-scroll-nav').on('click', function(event){
      event.preventDefault();
      var el = $(this).attr('data-anchor');

      var elWrapped = $('#'+ el);
      if ($(elWrapped).length) {
          scrollToDiv(elWrapped);
          history.pushState({}, '', '#' + el);
      }
      $('body').removeClass('guide-menu-toggled');
      $('.js-mob-btn').removeClass('toggled');
  });

  function scrollToDiv(element){
      if (element) {
          var a = document.getElementById("box");
          var navHeight;

          if (a !== null) {
            navHeight = a.clientHeight + 10;
          }
          else {
            navHeight = (parseInt($('.js-guide-body').css('padding-top')) - 10) || 90;
          }
          
          var offset = element.offset();
          var offsetTop = offset.top;
          var totalScroll = Math.round(offsetTop - navHeight);
          scrollIterationsCounter++;

          $('body,html').animate({
              scrollTop: totalScroll
          }, 500, function(){
            if (!checkScrollPosition(element) && scrollIterationsCounter < 4 && !isAnchorOnTheBottom(element)) {
              scrollToDiv(element);
            } else {
              scrollIterationsCounter = 0;
            }
          });

      }
  }

  function checkScrollPosition(element){
    if (element) {
      var a = document.getElementById("box");
      var navHeight;

      if (a !== null) {
        navHeight = a.clientHeight + 10;
      }
      else {
        navHeight = (parseInt($('.js-guide-body').css('padding-top')) - 10) || 90;
      }

      var offset = element.offset();
      var offsetTop = offset.top;
      var totalScroll = Math.round(offsetTop - navHeight);
      var pageScrollPosition = Math.round($(window).scrollTop());
      if (Math.abs(pageScrollPosition - totalScroll) > 30) {
        return false
      } else {
        return true
      }
    }
  }

  function isAnchorOnTheBottom(element){
    if (element) {
      var offset = element.offset();
      var offsetTop = offset.top;
      var windowHeight = $(window).height();
      var documentHeight = $(document).height();
      var elementBottomOffset = documentHeight - offsetTop;
      if (windowHeight  > elementBottomOffset) {
        return true
      } else {
        return false
      }
    }
  }

})();